import { getCookie, removeCookie, setCookie } from "../lib/cookies";

const COOKIE_NAME = "rewardPlugin_ref";
const REF_CODE_REGEX = /^[1-9A-HJ-NP-Za-km-z]{12}$/;

let ref: string | undefined;

export const loadReferralCode = (): string | undefined => {
  ref = ref || loadFromUrl() || loadFromCookies();

  if (ref) {
    setCookie(COOKIE_NAME, ref);
  }

  return ref;
};

export const getReferralCode = (): string | undefined => ref;

export const setReferralCode = (newRef: string): void => {
  if (!REF_CODE_REGEX.test(newRef)) {
    throw new Error("Invalid ref code");
  }

  ref = newRef;
  setCookie(COOKIE_NAME, ref);
};

export const clearReferralCode = (): void => {
  ref = undefined;
  removeCookie(COOKIE_NAME);
};

// local helpers

const loadFromUrl = (): string | undefined => {
  const match = /[?&]ref=([^&]+)/.exec(window.location.search);
  if (!match) return;

  const ref = match[1]!;
  if (!REF_CODE_REGEX.test(ref)) {
    return;
  }

  return ref;
};

const loadFromCookies = (): string | undefined => {
  const ref = getCookie(COOKIE_NAME);
  if (!ref || !REF_CODE_REGEX.test(ref)) {
    return;
  }

  return ref;
};
